<section class="p24 h100">
  <span class="bold f24 lh24 mb24 d-block" i18n>Create User</span>
    <div class="d-flex flex-column wrap-form">
      <form [formGroup]="form">
        <formly-form [form]="form" [fields]="fields" [model]="model"></formly-form>
      </form>
      <div class="f-gr-1"></div>
      <div class="d-flex my16">
        <button mat-stroked-button (click)="cancel()" i18n>Cancel</button>
        @if (data?.uuid) {
          <button
            class="mr16"
            mat-stroked-button
            (click)="drop2fa()"
            i18n>
            Reset 2FA
          </button>
        }
        <div class="f-gr-1"></div>
        <button [disabled]="form.invalid || disabled" mat-raised-button color="primary"
                (click)="create()" i18n>Save
        </button>
      </div>
    </div>

</section>
